var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mapbox-wordmark",attrs:{"href":"http://mapbox.com/about/maps","target":"_blank"}},[_vm._v("Mapbox")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164097ba","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/MapboxAttribution.vue
// module id = gEbC
// module chunks = 1